var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 36,
    viewBox: "0 0 55 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4719 33.3891C20.9654 33.3891 22.9867 31.2692 22.9867 28.654C22.9867 26.0388 20.9654 23.9189 18.4719 23.9189C15.9784 23.9189 13.957 26.0388 13.957 28.654C13.957 31.2692 15.9784 33.3891 18.4719 33.3891Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0461 33.3891C43.5396 33.3891 45.5609 31.2692 45.5609 28.654C45.5609 26.0388 43.5396 23.9189 41.0461 23.9189C38.5525 23.9189 36.5312 26.0388 36.5312 28.654C36.5312 31.2692 38.5525 33.3891 41.0461 33.3891Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0976 28.654H34.2719V4.03161C34.2719 3.24708 33.6655 2.61108 32.9174 2.61108H2.66797",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1658 28.654H8.53805C7.79 28.654 7.18359 28.0181 7.18359 27.2335V15.6326",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92578 9.71362H13.9555",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2734 9.71362H46.9378C47.473 9.71362 47.9582 10.0442 48.1755 10.5572L52.2161 20.092C52.2931 20.2738 52.3328 20.4703 52.3328 20.6689V27.2334C52.3328 28.018 51.7265 28.6539 50.9784 28.6539H46.6893",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2734 28.6541H36.5309",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeDelivery);
export default __webpack_public_path__ + "static/media/icone-delivery.2363c8ce1363af1f6535b0d83cf7962f.svg";
export { ForwardRef as ReactComponent };